import { type SettingsStructure } from "@client/settings/structure";
import { type GenericMap } from "@client/types";

export const getDrillDownStructure = (isText: boolean): SettingsStructure => {
  let layout: GenericMap<any> = {
    label: {
      label: "Label",
      def: "textRich"
    }
  };
  if (!isText) {
    layout = {
      ...layout,
      checked: {
        label: "Checked",
        def: "onOff",
        val: "off"
      },
      required: {
        label: "Required",
        def: "onOff",
        val: false
      },
      visible: {
        label: "Visible",
        def: "onOff",
        val: true
      }
    };
  }
  return layout;
};
